<template>
  <div
    class="total_chart_graph tooltip"
    v-if="itemWidth > 0"
    :style="{ width: adjustedWidth, 'margin-left': marginLeftPixel }"
  >
    <div class="chart_label_container">
      <i
        class="material-icons"
        :style="{ 'align-self': 'center', color: itemColor }"
      >
        &#xe3fa;
      </i>
      <div class="type_name_text">{{ itemText }}</div>
    </div>
    <div
      class="center_aligned_container"
      :style="{ 'border-radius': '8px', background: itemColor }"
    >
      {{ itemPercentage.toFixed(2) }}%
    </div>
    <div class="tooltip_content tooltip-bottom">
      <ChartToolTip
        v-bind:indicatorColor="itemColor"
        v-bind:label="itemText"
        v-bind:value="itemTotal"
        v-bind:unitText="unitText"
      />
    </div>
  </div>
</template>

<script>
import utils from '../../mixins/utils'
import ChartToolTip from '../common/ChartToolTip'

export default {
  name: 'RecycleTypeChartBar',
  components: { ChartToolTip },
  mixins: [utils],
  props: {
    itemWidth: {
      type: Number,
      default: 0
    },
    adjustedWidth: {
      type: String,
      default: '0%'
    },
    itemTotal: {
      type: Number,
      default: 0
    },
    unitText: {
      type: String,
      default: 'kg'
    },
    itemPercentage: {
      type: Number,
      default: 0.0
    },
    itemText: {
      type: String,
      default: ''
    },
    itemColor: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    marginLeftPixel: {
      type: String,
      default: '7px'
    }
  }
}
</script>

<style scoped>
.center_aligned_container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.type_name_text {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  word-wrap: brek-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: start;
}

.total_chart_graph {
  border-radius: 8px;
  display: grid;
  grid-template-rows: 2fr 4fr 1fr;
  box-sizing: border-box;
}

.chart_label_container {
  display: flex;
  align-self: center;
}

.tooltip {
  position: relative;
}

.tooltip .tooltip_content {
  visibility: hidden;
  text-align: left;
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltip_content {
  visibility: visible;
}

.tooltip .tooltip-bottom {
  top: 70%;
  margin-left: -20px;
  width: max-content;
}

.tooltip .tooltip-bottom::after {
  bottom: 100%;
  margin-left: -20px;
  border-color: transparent transparent black transparent;
}
</style>
